import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { v4 as SessionID } from 'uuid';
@Injectable({
  providedIn: 'root'
})
export class PrequotesignoffService {
  public _PrequotesignoffService = environment.PrequotesignoffService;
  public _httpOptions;
  public sessionId : string
  constructor(private http: HttpClient) { 
    this.sessionId = sessionStorage["SessionId"]
  this._httpOptions = {
    headers: new HttpHeaders({ 'SessionId':this.sessionId })
  };

  }

  GetPrequoteSignOffInitializeDetails(): Observable<any>{
    
    var Query = this._PrequotesignoffService + '/GetPrequoteSignOffInitializeDetails'  ;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  GetPrequoteSignOffById(customersitecode:string): Observable<any>{
    

    var Query = this._PrequotesignoffService + '/GetPrequoteSignOffById' +'/'+ customersitecode ;
    // console.log(Query);
    return this.http.get<{ data: any }>(Query,this._httpOptions);
  }
  
  // PrequoteSignOff(customersignoff: object) {
  //   console.log("Create");
  //   var Query = this._PrequotesignoffService + '/PrequoteSignOff';
  //   return this.http.post<{ data: any }>(Query, customersignoff);
  // }
  PrequoteSignOff(customersignoff: object) {
  

    // console.log("Update");
    var Query = this._PrequotesignoffService + '/PrequoteSignOff';
    // console.log(Query);
    return this.http.put<{ data: any }>(Query, customersignoff,this._httpOptions);
  }
}
